import { selectAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { ThemeColorToken, ThemeFontSizeToken } from '../theme-tokens';
import { inputConfig } from './input-theme';
const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    // Apply input theme, as Select and Input share most of their appearances
    ...inputConfig.variants?.outline,
    field: {
        // Apply input theme, as Select and Input share most of their appearances
        ...inputConfig.variants?.outline.field,
        // Give nested option elements color styles to match the select element.
        // Only applicable to Microsoft desktop browsers, will be ignored by browsers that use their own native styles.
        '> option, > optgroup': {
            color: ThemeColorToken.OnSurface,
            background: ThemeColorToken.Surface,
        },
    },
    icon: {
        fontSize: ThemeFontSizeToken.Small,
        color: ThemeColorToken.OnSurface,
        _disabled: {
            opacity: 1,
            color: ThemeColorToken.OnSurfaceSubdued,
        },
    },
});
const ghostStyle = definePartsStyle({
    // Apply input theme, as Select and Input share most of their appearances
    ...inputConfig.variants?.ghost,
    field: {
        // Apply input theme, as Select and Input share most of their appearances
        ...inputConfig.variants?.ghost.field,
        border: 'none',
        // Give nested option elements color styles to match the select element.
        // Only applicable to Microsoft desktop browsers, will be ignored by browsers that use their own native styles.
        '> option, > optgroup': {
            color: ThemeColorToken.OnSurface,
            background: ThemeColorToken.Surface,
        },
    },
    icon: {
        ...baseStyle.icon,
    },
});
export const selectConfig = defineMultiStyleConfig({
    defaultProps: {
        variant: 'outline',
    },
    variants: {
        outline: baseStyle,
        ghost: ghostStyle,
    },
});
//# sourceMappingURL=select-theme.js.map